class CartCount extends HTMLElement {
  constructor() {
    super();

    document.addEventListener(
      "cartUpdate",
      this._updateCartItemCount.bind(this)
    );
    document.addEventListener("cartAdd", this._updateCartItemCount.bind(this));
  }

  _updateCartItemCount(e) {
    this.innerHTML = `${e.detail.item_count === 0 ? "" : e.detail.item_count} ${
      e.detail.item_count === 0
        ? ""
        : e.detail.item_count === 1
        ? "item"
        : "items"
    }`;
  }
}

customElements.define("cart-count", CartCount);
